var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.124 2H2.882A.883.883 0 002 2.88v14.227c0 .486.396.881.882.881h7.664v-6.19H8.459V9.383h2.087V7.609c0-2.067 1.265-3.188 3.106-3.188.882 0 1.643.066 1.865.096v2.157H14.24c-1.002 0-1.2.474-1.2 1.175v1.54h2.393l-.312 2.415h-2.08V18h4.077a.883.883 0 00.882-.88V2.88a.874.874 0 00-.876-.88z",
    fill: "currentColor"
  })));
}

export default SvgFacebook;